import { render, staticRenderFns } from "./DehuDocumentViewer.vue?vue&type=template&id=6b28b05e&scoped=true"
import script from "./DehuDocumentViewer.vue?vue&type=script&lang=js"
export * from "./DehuDocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./DehuDocumentViewer.vue?vue&type=style&index=0&id=6b28b05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28b05e",
  null
  
)

export default component.exports